import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Formik, Form } from 'formik';
import { bindActionCreators } from 'redux';
import { withLocalize, Translate } from 'react-localize-redux';
import { Circles } from '../common/loadingComponent';
import { popupActions } from '../../store/popupStore';
import { userContextActions } from '../../store/userContextStore';
import { isNullOrUndefined, isRepiWeb } from '../../store/storeFunctions';
import { apiPost, getHostApi, getLanguage, parseQuery } from '../../store/apiWrapper';
import Message from '../common/message';
import BbInput from '../styling/bbInput';
import classnames from 'classnames';
import LanguageSelector from '../common/languageSelector';

import cribislogograyCz from '../../img/Cribis.cz_grey.svg';
import cribislogograySk from '../../img/Cribis.sk_grey.svg';
import cribislogowhiteCz from '../../img/Cribis.cz_white.svg';
import cribislogowhiteSk from '../../img/Cribis.sk_white.svg';
import criftimelinetrees from '../../img/CrifTimelineTrees.svg';

import RepiCzWhite from '../../img/repi/RepiCzWhite.svg';
import RepiSkWhite from '../../img/repi/RepiSkWhite.svg';
import RepiCzGrey from '../../img/repi/RepiCzGrey.svg';
import RepiSkGrey from '../../img/repi/RepiSkGrey.svg';
import RepiCz from '../../img/repi/RepiCzColor';
import RepiSk from '../../img/repi/RepiSkColor';

import cribisCz from "../../img/Cribis.cz_grey2.svg";
import cribisSk from "../../img/Cribis.sk_grey2.svg";
import irating from "../../img/iRating2.svg";
import margo from "../../img/margo2.svg";
import repi from "../../img/REPI.svg";
import crifCzColored from "../../img/CRIFcz_colored.svg";
import crifSkColored from "../../img/CRIFsk_colored.svg";

import './login.scss';

class LoginComponent extends React.Component {
    lastT = 0;

    state = {
        username: this.props.isChangePwd ? this.props.authentication.profile.username : '',
        password: '',
        loading: false,
        error: false,
        message: undefined,
        isExpired: false,
        password_validation: {
            minimal: false,
            uppercase: false,
            lowercase: false,
            digits: false,
            special_character: false,
            max_three_same_characters: false,
            no_6_repeatings: false,
            no_pointer_to_user: false,
        },
        isResendVisible: false,
    };

    constructor(props) {
        super(props);
        this.usernameRef = React.createRef();
    }

    render() {
        return (
            <>
                {localStorage.locales_login === 'blue' && <div
                    className={this.props.isChangePwd || this.state.isExpired ? 'app-screen app-loading-screen' : 'app-screen app-login-screen blue-background'}
                >
                    {!this.props.isChangePwd || this.state.isExpired && (
                        isRepiWeb()
                            ? <img alt="" className='cribis-logo' src={getLanguage() === 'sk-SK' ? RepiSkWhite : RepiCzWhite}></img>
                            : <img alt="" className='cribis-logo' src={getLanguage() === 'sk-SK' ? cribislogowhiteSk : cribislogowhiteCz}></img>
                    )}
                    {this.renderAsForm()}
                </div>}
                {localStorage.locales_login === 'tree' && <div>
                    <div className='login-language-flags'>
                        <LanguageSelector />
                    </div>
                    <div className="cribis-logo">
                        {!(this.props.authentication.loading || this.state.loading) && <img alt="" src={getLanguage() === 'sk-SK' ? cribislogograySk : cribislogograyCz}></img>}
                    </div>
                    <div className="app-screen app-loading-screen">
                        {(this.props.authentication.loading || this.state.loading) && (
                            isRepiWeb()
                                ? <img alt="" className='cribis-logo' src={getLanguage() === 'sk-SK' ? RepiSkGrey : RepiCzGrey}></img>
                                : <img alt="" className="cribis-logo" src={getLanguage() === 'sk-SK' ? cribislogograySk : cribislogograyCz}></img>
                        )}
                        {this.renderAsForm()}
                    </div>
                    <div className="cribis-tree">
                        <img alt="" src={criftimelinetrees} style={{ position: "absolute", bottom: "12vh", width: "100vw", opacity: "0.15" }}></img>
                    </div>
                </div>}
            </>
        );
    }

    componentDidMount = () => {
        this.props.resetLoginAttempt();
        if (this.isSsoLogin()) {
            const params = parseQuery(window.location.href);
            this.props.loginSsoToken(params.ssoToken, params.lang, window.location.href, this.props.addTranslationForLanguage, params.autologinToken);
        }
        else if (this.isHyperlinkSsoLogin()) {
            const params = parseQuery(window.location.href);
            this.props.loginSsoHyperlink(params.hyperlinkSsoToken, params.lang, window.location.href, this.props.addTranslationForLanguage,
                params.isLimited, params.returnUrl);
        }
        else if (this.props.authentication.isAuthorized) {
            if (!this.props.navbar) {
                if (window.location.pathname === '/login') {
                    if (window.location.href.indexOf('?returnUrl') > 0)
                        this.props.redirectBack(window.location.href);
                    else
                        this.props.redirectBack('/');
                } else {
                    this.props.redirectBack(window.location.href);
                }
            }
        }
        if (this.usernameRef.current !== null && this.usernameRef.current !== undefined)
            this.usernameRef.current.focus();

        // Browser back button event
        window.addEventListener('popstate', this.onBackButtonEvent);
    }

    componentDidUpdate = (prevProps, _) => {
        if (this.props.authentication.isAuthorized === false && !isNullOrUndefined(this.props.authentication.consent) &&
            (prevProps.authentication.consent !== this.props.authentication.consent)) {
            this.openConsentPopup(this.props.authentication.consent,
                (confirmed) => { this.props.verify(confirmed, this.props.authentication.guid, window.location.href) }
            );
        }

        if (!this.state.isExpired) {
            if (this.props.authentication.errorMessage === 'ExpiredPassword') {
                this.setState({ isExpired: true, username: this.props.authentication.profile.username });
            }
        }

        if (this.state.isExpired) {
            if (this.props.authentication.errorMessage !== 'ExpiredPassword') {
                this.setState({ isExpired: false });
            }
        }
    }

    renderAsForm = () => {
        if (!isNullOrUndefined(this.props.authentication) && this.props.authentication.loading || this.state.loading)
            return <Circles useLoginColor />;
        if (this.props.isChangePwd)
            return this.renderPwdChange();
        if (this.props.authentication.isAuthorized)
            return "";
        if (this.props.authentication.isAuthorized === false && this.props.authentication.errorMessage === 'ExpiredPassword')
            return this.renderPwdChange();
        if (this.props.authentication.is2FA && this.props.authentication.guid)
            return this.render2FAForm();
        return this.renderLoginForm();
    }

    renderPwdChange = () => {
        const repiWeb = isRepiWeb();

        if (this.isMobile()) {
            return (
                <div className={classnames("justify-content-center", { 'vertical-center': localStorage.locales_login === 'tree' })}>
                    <div className="columns is-centered" style={{ margin: '0' }}>
                        <div className='stage-2'>
                            {repiWeb ? this.renderPwdChangeOnlyFormRepi() : this.renderPwdChangeOnlyForm()}
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div className={classnames("justify-content-center", { 'vertical-center': localStorage.locales_login === 'tree' })}>
                <div className="columns is-centered">
                    <div className="stage-2">
                        <div className="columns stage-2-container">
                            <div className="column">
                                <div className="left-half">
                                    {repiWeb === true ? this.renderPwdChangeOnlyFormRepi() : this.renderPwdChangeOnlyForm()}
                                </div>
                            </div>
                            {!this.isMobile() && <div className="column">
                                <div className="right-half">
                                    <div className='text'>
                                        <div className='header'>{this.props.translate('PwdReset.ValidationText.Header')}</div>
                                        {this.renderRules()}
                                        <div className='footer'>{this.props.translate('PwdReset.ValidationText.Security')}</div>
                                    </div>
                                </div>
                            </div>}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderPwdChangeOnlyForm = () => {
        return (
            <div className={classnames("column", {
                "bb-login-box": localStorage.locales_login === 'tree',
                "bb-blue-login-box": localStorage.locales_login === 'blue'
            })}
            >
                <div style={{ width: '100%' }} align={this.isMobile() ? 'center' : 'left'}>
                    <img alt="" className='stage-2-container-cribis-logo' src={this.getAgentLanguage() === 'sk-SK' ? crifSkColored : crifCzColored}></img>
                </div>
                <div style={{ width: '100%' }} align={this.isMobile() ? 'center' : 'left'}>
                    <div className="bb-login-caption">{this.props.translate('PwdReset.CreateNewPassword.Caption')}</div>
                    <div className="bb-login-subcaption">{this.props.translate('PwdReset.CreateNewPassword.Subcaption')}</div>
                </div>
                <div className="bb-login-body">
                    {(this.state.error || !this.props.isChangePwd) &&
                        this.showError(
                            this.state.error ? 'error' : 'warning',
                            !this.state.error ? this.props.translate('Login.PasswordExpired') : this.state.message
                        )}
                    <Formik
                        enableReinitialize
                        initialValues={{
                            username: this.state.username,
                            oldPswd: '',
                            newPswd: '',
                            newPswd2: ''
                        }}
                        validate={values => {
                            let errors = {};
                            if (values.oldPswd === undefined || values.oldPswd === "")
                                errors.oldPswd = this.props.translate('Form.Validation.Required', { name: this.props.translate('PswdChange.OldPassword') });
                            if (values.newPswd === undefined || values.newPswd === "")
                                errors.newPswd = this.props.translate('Form.Validation.Required', { name: this.props.translate('PswdChange.NewPassword') });
                            if (values.newPswd2 === undefined || values.newPswd2 === "")
                                errors.newPswd2 = this.props.translate('Form.Validation.Required', { name: this.props.translate('PswdChange.ConfirmPassword') });
                            return errors;
                        }}
                        onSubmit={(values, { setSubmitting }) => this.handleSubmit('change', values, setSubmitting)}
                    >
                        {({ values, errors, touched, isSubmitting }) => <Form>
                            <BbInput name="username" type="text" disabled={this.state.username != ""} label={this.props.translate('Login.Username')}
                                placeholder={{ type: 'static' }} error={{ errors, touched }} icon={{ left: 'user' }} />
                            <BbInput name="oldPswd" type="password" label={this.props.translate('PswdChange.OldPassword')}
                                placeholder={{ type: 'static' }} error={{ errors, touched }} icon={{ left: 'lock' }} />
                            {this.isMobile() && <div className='stage-2-mobile'>{this.renderRules()}</div>}
                            <BbInput name="newPswd" type="password" label={this.props.translate('PswdChange.NewPassword')} onInput={this.validatePassword}
                                placeholder={{ type: 'static' }} error={{ errors, touched }} icon={{ left: 'lock' }} />
                            <BbInput name="newPswd2" type="password" label={this.props.translate('PswdChange.ConfirmPassword')}
                                placeholder={{ type: 'static' }} error={{ errors, touched }} icon={{ left: 'lock' }} />
                            {this.fieldsFilled(values) && !this.pswdMatch(values) &&
                                <p className="help is-danger">{this.props.translate('PswdChange.PswdsDontMatch')}</p>}
                            <div className="bb-group" style={{ display: "flex", justifyContent: "center" }}>
                                {this.props.isChangePwd &&
                                    <button className={classnames('bb-button bb-login-button gradient-1-gray',
                                        { 'is-square': localStorage.locales_button_style === 'square' })}
                                        type="button"
                                        value="{this.props.translate('PswdChange.Back')}"
                                        onClick={() => this.props.changePwdBack()}>{this.props.translate('PswdChange.Back')}
                                    </button>}
                                <button
                                    className={classnames('bb-button bb-login-button gradient-1',
                                        { 'bb-login-button-less-padding': this.state.loading, 'is-square': localStorage.locales_button_style === 'square' })}
                                    type="submit" disabled={isSubmitting || !this.isFormValid(values)}
                                >
                                    <Translate id='PswdChange.SubmitBtn' />
                                </button>
                            </div>
                        </Form>}
                    </Formik>
                </div>
                {localStorage.locales_login === 'blue' && <div className='blue-login-language-flags'>
                    <LanguageSelector />
                </div>}
                {this.isMobile() && <div className='text-x1' style={{ fontSize: '15px', marginTop: '10px', width: '80%', marginLeft: '10%', color: 'black' }}>
                    {this.props.translate('PwdReset.ValidationText.Security')}
                </div>}
                <div className={`crif-copyright-text text-x1`}>
                    &copy; CRIF - {this.getAgentLanguage() === 'sk-SK' ? 'Slovak' : 'Czech'} Credit Bureau, a.s.
                </div>
                <div>
                    <table width='100%' border='0' style={{ marginTop: '10px', borderCollapse: 'initial' }}>
                        <tbody>
                            <tr>
                                <td style={{ padding: '0px 10px 10px 10px' }} width='31%'>
                                    <a target="_blank" href={this.getAgentLanguage() === 'sk-SK' ? 'https://www.cribis.sk/' : 'https://www.cribis.cz/'}>
                                        <img className='reset-password-container-logos-logo' src={this.getAgentLanguage() === 'sk-SK' ? cribisSk : cribisCz} />
                                    </a>
                                </td>
                                <td style={{ padding: '6px 10px 10px 10px' }} width='23%'>
                                    <a target="_blank" href={this.getAgentLanguage() === 'sk-SK' ? 'https://new.irating.sk' : 'https://new.irating.cz'}>
                                        <img className='reset-password-container-logos-logo' src={irating} />
                                    </a>
                                </td>
                                <td style={{ padding: '6px 10px 10px 10px' }} width='23%'>
                                    <a target="_blank" href={this.getAgentLanguage() === 'sk-SK' ? 'https://sk.margo.crif.com' : 'https://cz.margo.crif.com'}>
                                        <img className='reset-password-container-logos-logo' src={margo} />
                                    </a>
                                </td>
                                <td style={{ padding: '6px 10px 10px 10px' }} width='23%'>
                                    <a target="_blank" href={this.getAgentLanguage() === 'sk-SK' ? 'https://www.repi.sk/' : 'https://www.repi.cz/'}>
                                        <img className='reset-password-container-logos-logo' src={repi} />
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }

    renderPwdChangeOnlyFormRepi = () => {
        const Logo = this.getAgentLanguage() === 'sk-SK' ? RepiSk : RepiCz;

        return (
            <div className={classnames("column", {
                "bb-login-box": localStorage.locales_login === 'tree',
                "bb-blue-login-box": localStorage.locales_login === 'blue'
            })}
            >
                <div style={{ width: '100%' }} align={this.isMobile() ? 'center' : 'left'}>
                    <Logo className='stage-2-container-cribis-logo' />
                </div>
                <div style={{ width: '100%' }} align={this.isMobile() ? 'center' : 'left'}>
                    <div className="bb-login-caption">{this.props.translate('PwdReset.CreateNewPassword.Caption')}</div>
                    <div className="bb-login-subcaption">{this.props.translate('PwdReset.CreateNewPassword.Subcaption.Repi')}</div>
                </div>
                <div className="bb-login-body">
                    {(this.state.error || !this.props.isChangePwd) &&
                        this.showError(
                            this.state.error ? 'error' : 'warning',
                            !this.state.error ? this.props.translate('Login.PasswordExpired') : this.state.message
                        )}
                    <Formik
                        enableReinitialize
                        initialValues={{
                            username: this.state.username,
                            oldPswd: '',
                            newPswd: '',
                            newPswd2: ''
                        }}
                        validate={values => {
                            let errors = {};
                            if (values.oldPswd === undefined || values.oldPswd === "")
                                errors.oldPswd = this.props.translate('Form.Validation.Required', { name: this.props.translate('PswdChange.OldPassword') });
                            if (values.newPswd === undefined || values.newPswd === "")
                                errors.newPswd = this.props.translate('Form.Validation.Required', { name: this.props.translate('PswdChange.NewPassword') });
                            if (values.newPswd2 === undefined || values.newPswd2 === "")
                                errors.newPswd2 = this.props.translate('Form.Validation.Required', { name: this.props.translate('PswdChange.ConfirmPassword') });
                            return errors;
                        }}
                        onSubmit={(values, { setSubmitting }) => this.handleSubmit('change', values, setSubmitting)}
                    >
                        {({ values, errors, touched, isSubmitting }) => <Form>
                            <BbInput name="username" type="text" disabled={this.state.username != ""} label={this.props.translate('Login.Username')}
                                placeholder={{ type: 'static' }} error={{ errors, touched }} icon={{ left: 'user' }} />
                            <BbInput name="oldPswd" type="password" label={this.props.translate('PswdChange.OldPassword')}
                                placeholder={{ type: 'static' }} error={{ errors, touched }} icon={{ left: 'lock' }} />
                            {this.isMobile() && <div className='stage-2-mobile'>{this.renderRules()}</div>}
                            <BbInput name="newPswd" type="password" label={this.props.translate('PswdChange.NewPassword')} onInput={this.validatePassword}
                                placeholder={{ type: 'static' }} error={{ errors, touched }} icon={{ left: 'lock' }} />
                            <BbInput name="newPswd2" type="password" label={this.props.translate('PswdChange.ConfirmPassword')}
                                placeholder={{ type: 'static' }} error={{ errors, touched }} icon={{ left: 'lock' }} />
                            {this.fieldsFilled(values) && !this.pswdMatch(values) &&
                                <p className="help is-danger">{this.props.translate('PswdChange.PswdsDontMatch')}</p>}
                            <div className="bb-group" style={{ display: "flex", justifyContent: "center" }}>
                                {this.props.isChangePwd &&
                                    <button className={classnames('bb-button bb-login-button gradient-1-gray',
                                        { 'is-square': localStorage.locales_button_style === 'square' })}
                                        type="button"
                                        value="{this.props.translate('PswdChange.Back')}"
                                        onClick={() => this.props.changePwdBack()}>{this.props.translate('PswdChange.Back')}
                                    </button>}
                                <button
                                    className={classnames('bb-button bb-login-button gradient-1',
                                        { 'bb-login-button-less-padding': this.state.loading, 'is-square': localStorage.locales_button_style === 'square' })}
                                    type="submit" disabled={isSubmitting || !this.isFormValid(values)}
                                >
                                    <Translate id='PswdChange.SubmitBtn' />
                                </button>
                            </div>
                        </Form>}
                    </Formik>
                </div>
                {localStorage.locales_login === 'blue' && <div className='blue-login-language-flags'>
                    <LanguageSelector />
                </div>}
                {this.isMobile() && <div className='text-x1' style={{ fontSize: '15px', marginTop: '10px', width: '80%', marginLeft: '10%', color: 'black' }}>
                    {this.props.translate('PwdReset.ValidationText.Security')}
                </div>}
                <div className={`crif-copyright-text text-x1`}>
                    &copy; {this.getAgentLanguage() === 'sk-SK' ? 'CRIF - Slovak Credit Bureau, s.r.o.' : 'CRIF - Registr platebních informací s.r.o.'}
                </div>
            </div>
        )
    }

    render2FAForm = () => {
        return (
            <div className={classnames("justify-content-center", { 'vertical-center': localStorage.locales_login === 'tree' })}>
                <div className="columns is-centered">
                    <div className={classnames("column", {
                        "bb-login-box": localStorage.locales_login === 'tree',
                        "bb-blue-login-box": localStorage.locales_login === 'blue'
                    })}>
                        <h4 className="bb-login-caption has-text-centered">{this.props.translate('Login.FormCaption')}</h4>
                        <div className="progress-wrapper">
                            <div className='bb-login-progress' />
                        </div>
                        <div className="bb-login-body">
                            {(this.props.authentication.success !== undefined && !this.props.authentication.success) &&
                                this.showError('warning', this.props.authentication.errorMessage, true)
                            }
                            {(!this.props.authentication.revoked && this.props.authentication.information) &&
                                this.showError('info', 'Login.TwoFactorAuth.SendInformation', true, this.props.authentication.information)
                            }
                            {(this.props.authentication.revoked) &&
                                this.showError('warning', 'Login.TwoFactorAuth.HelpDeskError', true)
                            }
                            <Formik
                                initialValues={{
                                    username: this.state.username,
                                    password: this.state.password,
                                    smstoken: ''
                                }}
                                onSubmit={(values, { setSubmitting }) => this.handleSubmit('2FA', values, setSubmitting)}
                                render={({ values, setSubmitting }) => (
                                    <Form>
                                        {!this.isSsoLogin() && !this.isHyperlinkSsoLogin() &&
                                            <>
                                                <BbInput innerRef={this.usernameRef} name="username" type="text" disabled={this.state.username != ""} label={this.props.translate('Login.Username')}
                                                    placeholder={{ type: 'static' }} icon={{ left: 'user' }} />
                                                <BbInput name="password" type="password" disabled={this.state.password != ""} label={this.props.translate('Login.Password')}
                                                    placeholder={{ type: 'static' }} icon={{ left: 'lock' }} />
                                            </>
                                        }
                                        <BbInput name="smstoken" type="text" label={this.props.translate('Login.TwoFactorAuth.Code')}
                                            placeholder={{ type: 'static' }} icon={{ left: 'envelope' }} />
                                        {this.renderSmsTokenButtons(values, setSubmitting)}
                                    </Form>
                                )} />
                        </div>
                        {localStorage.locales_login === 'blue' &&
                            <div className='blue-login-language-flags'>
                                <LanguageSelector showLoading={false} />
                            </div>
                        }
                    </div>
                </div>
            </div>
        );
    }

    renderSmsTokenButtons = (values, setSubmitting) => {
        setTimeout(() => this.setState({ isResendVisible: true }), 30000);
        return (
            <>
                {(this.state.isResendVisible && !this.props.authentication.revoked) &&
                    <div className="bb-group" style={{
                        fontSize: '.9em',
                        textAlign: localStorage.locales_login === 'tree' ? 'right' : 'center',
                        paddingBottom: '.5em'
                    }}>
                        <span
                            className={classnames('bb-link', { 'is-normal': localStorage.locales_url_format === 'normal' })}
                            onClick={() => this.handleSubmit('resend', values, setSubmitting)}
                        >
                            <Translate id='Login.TwoFactorAuth.ResendCode' />
                        </span>
                    </div>
                }
                <div className="bb-group" style={{ display: "flex", justifyContent: "center" }}>
                    <button type="submit" disabled={this.smsSubmitDisabled(values)}
                        className={classnames('bb-button bb-login-button gradient-1', {
                            'bb-login-button-less-padding': this.props.authentication.loading,
                            'is-square': localStorage.locales_button_style === 'square'
                        })}
                    >
                        <Translate id='Login.TwoFactorAuth.SubmitSms' />
                    </button>
                </div>
            </>
        )
    }

    renderLoginForm = () => {
        return (
            <div className={classnames("justify-content-center", { 'vertical-center': localStorage.locales_login === 'tree' })}>
                <div className="columns is-centered">
                    <div className={classnames("column", {
                        "bb-login-box": localStorage.locales_login === 'tree',
                        "bb-blue-login-box": localStorage.locales_login === 'blue'
                    })}>
                        <h4 className="bb-login-caption has-text-centered">{this.props.translate('Login.FormCaption')}</h4>
                        <div className="progress-wrapper">
                            <div className='bb-login-progress' />
                        </div>
                        <div className="bb-login-body">
                            {(this.props.authentication.success !== undefined && !this.props.authentication.success) &&
                                this.showError('warning', this.props.authentication.errorMessage, true)
                            }
                            <Formik
                                initialValues={{
                                    username: this.state.username,
                                    password: '',
                                }}
                                onSubmit={(values, { setSubmitting }) => this.handleSubmit('login', values, setSubmitting)}
                                render={({ values }) => (
                                    <Form>
                                        <BbInput innerRef={this.usernameRef} name="username" type="text" label={this.props.translate('Login.Username')}
                                            placeholder={{ type: 'static' }} icon={{ left: 'user' }} />
                                        <BbInput name="password" type="password" label={this.props.translate('Login.Password')}
                                            placeholder={{ type: 'static' }} icon={{ left: 'lock' }} />
                                        {this.renderLoginButtons(values)}
                                    </Form>
                                )} />
                        </div>
                        {localStorage.locales_login === 'blue' &&
                            <div className='blue-login-language-flags'>
                                <LanguageSelector showLoading={false} />
                            </div>
                        }
                    </div>
                </div>
            </div>
        );
    }

    renderLoginButtons = (values) => {
        return (
            <>
                <div className="bb-group" style={{ display: "flex", justifyContent: "center" }}>
                    <button type="submit" disabled={this.loginSubmitDisabled(values)}
                        className={classnames('bb-button bb-login-button gradient-1', {
                            'bb-login-button-less-padding': this.props.authentication.loading,
                            'is-square': localStorage.locales_button_style === 'square'
                        })}
                    >
                        <Translate id='Login.Login' />
                    </button>
                </div>
                <div className="bb-group" style={{
                    fontSize: '.9em',
                    textAlign: localStorage.locales_login === 'tree' ? 'right' : 'center',
                    paddingTop: localStorage.locales_login === 'tree' ? '.5em' : '1.5em'
                }}>
                    <Link className={classnames('bb-link', { 'is-normal': localStorage.locales_url_format === 'normal' })}
                        to="/lost-password">{this.props.translate('Login.LostPassword')}</Link>
                </div>
            </>
        );
    }

    validatePassword = (e) => {
        var pass = e.target.value;
        apiPost(getHostApi() + '/api/account/validate-pwd', null, { username: this.state.username, newPswd: pass, t: Date.now() },
            (res, lastT = this.lastT) => {
                if (res.data !== null && res.data.t > lastT) {
                    this.setLastT(res.data.t);
                    pass = document.getElementsByName("newPswd")[0];
                    if (pass != null) pass = pass.value;
                    if (pass == null || pass == '') {
                        this.setState({ password_validation: this.getFalseValidationRules() });
                        return;
                    }
                    this.setState({ password_validation: res.data });
                }
            }
        );
    }

    handleSubmit = (type, values, setSubmitting) => {
        if (type === 'login') {
            this.setState({ username: values.username, password: values.password });
            this.props.login(values.username, values.password, window.location.href, this.props.authentication.guid, null);
            if (setSubmitting !== undefined)
                setSubmitting(false);
            return;
        }
        if (type === '2FA' || type === 'resend') {
            const smsToken = type === 'resend' ? null : values.smstoken.trim();
            if (this.isSsoLogin()) {
                const params = parseQuery(window.location.href);
                this.props.loginSsoToken(params.ssoToken, params.lang, window.location.href, this.props.addTranslationForLanguage, params.autologinToken, this.props.authentication.guid, smsToken);
            } else if (this.isHyperlinkSsoLogin()) {
                const params = parseQuery(window.location.href);
                this.props.loginSsoHyperlink(params.hyperlinkSsoToken, params.lang, window.location.href, this.props.addTranslationForLanguage, params.isLimited, params.returnUrl, this.props.authentication.guid, smsToken);
            } else {
                this.setState({ username: values.username });
                this.props.login(values.username, values.password, window.location.href, this.props.authentication.guid, smsToken);
            }
            if (setSubmitting !== undefined)
                setSubmitting(false);
            return;
        }
        if (type === 'change') {
            this.setState({ loading: true, error: false, message: undefined });
            apiPost(getHostApi() + '/api/account/change-pwd', undefined, { ...values, repi: isRepiWeb() },
                (res) => {
                    if (res.data === null)
                        this.setState({ error: true, message: res.error.errorMessage });
                    else if (!res.data.success)
                        this.setState({ error: true, message: res.data.errorMessage, password_validation: this.getFalseValidationRules() });
                    else
                        this.props.login(values.username, values.newPswd, window.location.href, null, null);
                },
                (err) => this.setState({ error: true, message: err }),
                () => {
                    this.setState({ loading: false });
                    if (setSubmitting !== undefined)
                        setSubmitting(false);
                }
            );
            return;
        }
    }

    getFalseValidationRules = () => {
        return {
            minimal: false,
            uppercase: false,
            lowercase: false,
            digits: false,
            special_character: false,
            max_three_same_characters: false,
            no_6_repeatings: false,
            no_pointer_to_user: false,
        };
    }

    renderRules = () => {
        return (
            <>
                <div className={classnames("rule", { "validated": this.state.password_validation.minimal === true })}>
                    {this.props.translate('PwdReset.ValidationText.Minimal')}
                </div>
                <div className={classnames("rule", { "validated": this.state.password_validation.uppercase === true })}>
                    {this.props.translate('PwdReset.ValidationText.Uppercase')}
                </div>
                <div className={classnames("rule", { "validated": this.state.password_validation.lowercase === true })}>
                    {this.props.translate('PwdReset.ValidationText.Lowercase')}
                </div>
                <div className={classnames("rule", { "validated": this.state.password_validation.digits === true })}>
                    {this.props.translate('PwdReset.ValidationText.Digits')}
                </div>
                <div className={classnames("rule", { "validated": this.state.password_validation.special_character === true })}>
                    {this.props.translate('PwdReset.ValidationText.SpecialCharacter')}
                </div>
                <div className={classnames("rule", { "validated": this.state.password_validation.max_three_same_characters === true })}>
                    {this.props.translate('PwdReset.ValidationText.MaxThreeSameCharacters')}
                </div>
                <div className={classnames("rule", { "validated": this.state.password_validation.no_6_repeatings === true })}>
                    {this.props.translate('PwdReset.ValidationText.No6Repeatings')}
                </div>
                <div className={classnames("rule", { "validated": this.state.password_validation.no_pointer_to_user === true })}>
                    {this.props.translate('PwdReset.ValidationText.NoPointerToUser')}
                </div>
            </>
        );
    }

    setLastT = (t) => {
        this.lastT = t;
    }

    showError = (type, message, margin, data = undefined) => {
        if (isNullOrUndefined(message))
            return "";
        let msg = this.props.translate(message);
        if (!isNullOrUndefined(data))
            msg = msg.replace("${0}", data);
        let style = { fontSize: '.8em' };
        if (!isNullOrUndefined(margin))
            style = { ...style, marginBottom: "0.5em" }
        return <Message type={type} message={this.checkTranslation(msg)} style={style} options={{ renderInnerHtml: true }} shadowed />;
    };

    checkTranslation = (translation) => {
        if (translation.startsWith('-') && translation.endsWith('-'))
            return translation.substring(1, translation.length - 1);
        return translation;
    }

    openConsentPopup = (data, onOk) => {
        this.props.showPopup("consentPopup", {
            data: data,
            open: true,
            ok: (confirmed) => {
                onOk(confirmed);
                this.props.hidePopup();
            }
        });
    }

    onBackButtonEvent = (e) => {
        e.preventDefault();
        this.props.changePwdBack();
    }

    pswdMatch = (values) => values.newPswd === values.newPswd2;
    isFormValid = (values) => this.fieldsFilled(values) && this.pswdMatch(values);
    fieldsFilled = (values) => values.username !== '' && values.oldPswd !== '' && values.newPswd !== '' && values.newPswd2 !== '';
    loginSubmitDisabled = (values) => this.props.authentication.loading || !values.username || !values.password;
    smsSubmitDisabled = (values) => this.props.authentication.loading || !values.smstoken;
    getAgentLanguage = () => this.props.authentication.profile.agentLanguage;
    isMobile = () => window.innerWidth <= 992;
    isSsoLogin = () => window.location.href.indexOf('?ssoToken') > 0;
    isHyperlinkSsoLogin = () => window.location.href.indexOf('?hyperlinkSsoToken') > 0;
}

export default withLocalize(connect(
    state => state.userContext,
    dispatch => bindActionCreators({ ...userContextActions, ...popupActions }, dispatch)
)(LoginComponent));
